import { Box, Grid } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import React from "react";
import StreamIcon from "../../../../../app/images/striimline/stream-node.svg";
import { Handle, NodeProps, Position } from "reactflow";
import { handleStyles, hideHandleStyles } from "./node.styles";
import { NodeStats, showStats } from "./node.commons";
import { streamNodeStyles } from "./styles/stream-node.styles";
import StreamNodeAdd from "../add-new-node/add-new-node";
import { useAppSelector } from "src/stores/redux/hooks";
import { getAppStatus, getSelectedNode } from "../helpers/selectors";
import StreamPreview from "../stream-preview/stream-preview";
import { FlowStatus } from "src/status-management";

export interface StreamNodeData {
    label?: string;
    isDimmed?: boolean;
    [key: string]: any;
}

const StyledStreamIcon = (StreamIcon as unknown) as React.ComponentType<React.SVGProps<SVGSVGElement>>;

const isStreamFull = stats => {
    if (!stats) return false;
    else return !!stats?.["most-recent-data"]?.["stream-full"];
};

const StreamNode = ({ id, data, sourcePosition, targetPosition }: NodeProps<StreamNodeData>) => {
    const appStatus = useAppSelector(getAppStatus);
    const selectedNode = useAppSelector(getSelectedNode);
    const selected = selectedNode?.id === id;
    const isBackPressured = appStatus === FlowStatus.RUNNING && isStreamFull(data?.stats);

    return (
        <Grid
            height={"32px"}
            container
            justifyContent={"center"}
            sx={[
                streamNodeStyles.container,
                !!data.isDimmed && { opacity: 0.5, filter: "grayscale(1)" }
            ] as SxProps<Theme>}
            data-test-id={`node_container_${data?.metaObjectId === "temp-node" ? "New " : ""}${data.label}`}
        >
            <Box sx={{ "& rect": { fill: isBackPressured ? "#DB2A4A" : "auto" } }}>
                <StyledStreamIcon
                    style={{
                        width: "32px",
                        height: "32px",
                        border: selected ? "2px solid #089bee" : "none",
                        borderRadius: "16px",
                        transform: selected ? "scale(1.2)" : "scale(1)",
                        boxShadow: `0 4px 12px ${selected ? "#089bee59" : "rgba(0, 0, 0, 0.1)"}`,
                        fill: "none"
                    }}
                />
            </Box>

            {selected && appStatus === "CREATED" ? <StreamNodeAdd nodeId={id} data={data} /> : null}
            {appStatus && ["RUNNING", "STOPPED", "DEPLOYED"].includes(appStatus) && selected && (
                <StreamPreview nodeId={id} data={data} />
            )}
            {showStats(appStatus) && <NodeStats stats={data.stats} />}
            <Handle type="source" position={sourcePosition || Position.Bottom} style={hideHandleStyles} />
            <Handle type="target" position={targetPosition || Position.Top} style={hideHandleStyles} />
        </Grid>
    );
};

export default StreamNode;
